import { useCallback, useEffect } from "react"
import { WalletInfo } from "types/baseType"
import { useAppDispatch, useAppSelector } from "./redux/hooks";
import { setIsConnected } from "./redux/slices/walletSlice";
import { useOkxBitcoinWallet } from "./wallet/useOkxBitcoinWalletProvider";
import { useUnisatWallet } from "./wallet/useUnisatWalletProvider";

const useWalletConnectNoEvm = () => {
    const { brc20 } = useAppSelector((state) => state.app)
    const { isConnected } = useAppSelector((state) => state.wallet)
    const { isConnected: isConnectedOxk, connect: connectOkx, disconnected: disconnectedOkx } = useOkxBitcoinWallet()
    const { isConnected: isConnectedUnisat, connect: connectUnisat, disconnected: disconnectedUnisat } = useUnisatWallet()
    const dispatch = useAppDispatch()


    const connectWallet = useCallback(async (walletInfo: WalletInfo) => {
        try {
            if(!brc20) return
            if(isConnected) return;
            const walletName = walletInfo.name.toLowerCase()
            if(walletName === 'okxwallet') {
                await connectOkx()
            } else {
                await connectUnisat()
            }
            
        } catch(error) {

        }
    }, [brc20, connectOkx, connectUnisat, isConnected])


    useEffect(() => {
        dispatch(setIsConnected(isConnectedOxk || isConnectedUnisat))
    }, [dispatch, isConnectedOxk, isConnectedUnisat])

    return { connectWallet }
}

export default useWalletConnectNoEvm